import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { Loader2 } from "lucide-react";

export default function TokenRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const response = await axios.get(`${API}/t/${token}`);
        const { redirect_url } = response.data;
        
        if (redirect_url) {
          // Check if external URL
          if (redirect_url.startsWith("http")) {
            window.location.href = redirect_url;
          } else {
            navigate(redirect_url, { replace: true });
          }
        } else {
          setError("No destination configured for this artifact.");
        }
      } catch (err) {
        if (err.response?.status === 404) {
          setError("This token is not recognized.");
        } else if (err.response?.status === 410) {
          setError("This artifact has been deactivated.");
        } else {
          setError("Something went wrong. Please try again.");
        }
      }
    };

    if (token) {
      handleRedirect();
    }
  }, [token, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-wedding-black flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-wedding-gold/10 flex items-center justify-center">
            <span className="text-3xl">💫</span>
          </div>
          <h1 className="font-serif text-2xl text-wedding-ivory mb-4">Oops!</h1>
          <p className="text-wedding-ivory/60 mb-8">{error}</p>
          <button 
            onClick={() => navigate("/")}
            className="btn-secondary"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-wedding-black flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-wedding-gold animate-spin mx-auto mb-4" />
        <p className="text-wedding-ivory/60">Redirecting to your destination...</p>
      </div>
    </div>
  );
}
